import { editCardModalStyles } from "@insite/content-library/Widgets/SavedPayments/SavedPaymentsEditCardModal";

editCardModalStyles.countryGridItem = { width: [6, 6, 7, 7, 7] };
editCardModalStyles.stateGridItem = { width: [6, 6, 5, 5, 5] };
editCardModalStyles.cityGridItem = { width: [6, 6, 7, 7, 7] };
editCardModalStyles.postalCodeGridItem = { width: [6, 6, 5, 5, 5] };
